<template><div><h1 id="abrechnung-datenerfassung" tabindex="-1"><a class="header-anchor" href="#abrechnung-datenerfassung"><span>Abrechnung Datenerfassung</span></a></h1>
<p>Abrechnung Datenerfassung — Zeigt die Anzahl erfassten/mutierten Datensätze</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Programm zur leistungsorientierten Abrechnung von Erfassungsleistungen der BenutzerInnen. Die Auswertung erlaubt die Eingabe von bestimmten Parametern und kann im Hintergrund gestartet werden. Das gezeigte Fenster dient sowohl der Definition des Jobs als auch als Protokoll über durchgeführte Auswertungen.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Auswertungen → Datenerfassung → Abrechnung Datenerfassung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Abrechn.Datum/Nr.</dt>
<dd>Abrechnungsdatum (Erfassungsdatums des Jobs) und Laufnummer zur Identifikation des Jobs (wird vom System vergeben).</dd>
<dt>Zeitraum</dt>
<dd>Datum von/bis, Zeitraum der Auswertung</dd>
<dt>BenutzerInnen</dt>
<dd>Benutzerkennzeichen, die ausgewertet werden sollen. Mit Komma trennen, mit ! ausschliessen, * = alle</dd>
<dt>Pauschale pro erfasste Adresse</dt>
<dd>Vergütungsbetrag pro erfasste Adresse</dd>
<dt>Pauschale pro erfassten Auftragskopf</dt>
<dd>Vergütungsbetrag pro erfassten Auftragskopf</dd>
<dt>Pauschale pro geänderte Adresse</dt>
<dd>Vergütungsbetrag pro Adressmutation</dd>
<dt>Pauschale pro erfasste Auftragsposition</dt>
<dd>Vergütungsbetrag pro erfasste Auftragsposition</dd>
<dt>Zählungsergebnis Adressen</dt>
<dd>Anzahl erfasste Adressen und Vergütungsbetrag für die Erfassungsarbeit</dd>
<dt>Zählungsergebnis Auftragsköpfe</dt>
<dd>Anzahl erfasste Auftragsköpfe und Vergütungsbetrag für die Erfassungsarbeit</dd>
<dt>Zählungsergebnis AdressMut</dt>
<dd>Anzahl Adressmutationen und Vergütungsbetrag für die Erfassungsarbeit</dd>
<dt>Zählungsergebnis Auftragspos</dt>
<dd>Anzahl erfasste Auftragspositionen und Vergütungsbetrag für die Erfassungsarbeit.</dd>
<dt>Total Abrechnung</dt>
<dd>Total Anzahl Erfassungen/Mutationen über alle 4 Bereiche und Total Vergütungswert über alle 4 Bereiche.</dd>
<dt>Erfasste Aufträge nach Bestellart</dt>
<dd>Die Anzahl erfassten Aufträge und Auftragspositionen werden pro Bestellart angezeigt. Die Anzeige ist 3-Spaltig und beinhaltet Bestellart, Anzahl Erfassungen und Vergütungsbetrag pro Bestellart.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="anschauen" tabindex="-1"><a class="header-anchor" href="#anschauen"><span>anschauen</span></a></h3>
<p>Dient für das scrollen in &quot;Erfasste Aufträge nach Bestellart&quot;</p>
<h3 id="zahllauf" tabindex="-1"><a class="header-anchor" href="#zahllauf"><span>Zähllauf</span></a></h3>
<p>Berechnet die Werte für die eingegebenen Parameter</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


